import { freeDescriptorCode } from 'constants/free';
import { t } from '@lingui/macro';
import { BaseMeta } from 'types';

export const getMetasDisplayName = (metas: BaseMeta[]): string[] => {
    let isFree = false;

    let labels = [
        ...new Set(
            metas.reduce<string[]>((acc, meta) => {
                if (meta.code) {
                    // The Free tag should always be shown last
                    if (meta.code === freeDescriptorCode) {
                        isFree = true;

                        return acc;
                    }

                    acc.push(t({ id: meta.code }));
                }

                return acc;
            }, []),
        ),
    ];

    // The Free tag should always be shown last
    if (isFree) {
        labels.push(t({ id: freeDescriptorCode }));
    }

    return labels;
};
